import moment from 'moment';

const readEpochDate = (value, boundary) => {
  if (!value) return null;
  const parsed = moment(value, 'YYYY-MM-DD', true);
  if (!parsed.isValid()) return null;
  return boundary === 'end' ? parsed.endOf('day').valueOf() : parsed.startOf('day').valueOf();
};

/** `inicio`/`fim` em YYYY-MM-DD e `usuarioId` ou `inspetorId` na query. */
export const readPeriodoInspetorQuery = (search) => {
  const params = new URLSearchParams(search || '');
  const raw = params.get('usuarioId') || params.get('inspetorId');
  const ids = raw ? raw.split(',').map((id) => id.trim()).filter(Boolean) : [];
  return {
    inicio: readEpochDate(params.get('inicio'), 'start'),
    fim: readEpochDate(params.get('fim'), 'end'),
    ids,
  };
};

export const applyPeriodoInspetorQuery = (base, search, { idKey = 'usuarioId', asArray = true } = {}) => {
  const { inicio, fim, ids } = readPeriodoInspetorQuery(search);
  if (inicio == null && fim == null && !ids.length) return base;
  return {
    ...base,
    ...(inicio != null ? { inicio } : {}),
    ...(fim != null ? { fim } : {}),
    ...(ids.length ? { [idKey]: asArray ? ids : ids[0] } : {}),
  };
};
